import styled from "styled-components";
import { spacing } from "../../design-system/tokens/spacing";
import { typographyMixin } from "../../design-system/tokens/typography";
import { rawColors } from "../../design-system/tokens/colors";
import { duration, easing } from "../../design-system/tokens/transitions";

export const CardButton = styled.button`
  /* Reset native button styles */
  appearance: none;
  margin: 0;
  padding: 0;
  font: inherit;
  text-align: left;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  gap: ${spacing[5]};
  width: 100%;
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[100]};
  border-radius: 12px;
  overflow: hidden;
  transition: border-color ${duration.fast} ${easing.smooth}, box-shadow ${duration.fast} ${easing.smooth};

  &:hover {
    border-color: ${rawColors.stroke[200]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.72;
  }

  &:disabled:hover {
    border-color: ${rawColors.stroke[100]};
  }

  &:focus-visible {
    outline: none;
    border-color: ${rawColors.primary[500]};
    box-shadow: 0 0 0 2px ${rawColors.primary[100]};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2] /* 8px between header and description */};
  padding: ${spacing[3]} ${spacing[3]} 0;
`;

/**
 * Description block: clamped to 3 lines (~54px) so footers align across
 * cards regardless of copy length.
 */
export const Description = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.highEmphasis};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  min-height: 54px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${spacing[2]} ${spacing[3]};
  border-top: 1px solid ${rawColors.stroke[100]};
`;
